<script setup lang="ts">
interface HeaderNavUserMenuLinkProps {
  cypress?: string;
  icon?: string[] | Component;
  iconClass?: string;
  linkClass?: string;
  title: string;
  to: string;
  target?: string;
  /** When true, shows an orange "New" pill next to the title */
  showNew?: boolean;
}

const props = withDefaults(defineProps<HeaderNavUserMenuLinkProps>(), {
  cypress: undefined,
  icon: () => [],
  iconClass: '',
  linkClass: undefined,
  title: '',
  to: '',
  target: '',
  showNew: false,
});
const isFontAwesomeIcon = (icon: string[] | Component): icon is string[] =>
  Array.isArray(icon);

const dataCy = computed(() =>
  props.cypress ? `${props.cypress}-header-nav-user-menu-link` : '',
);
</script>

<template>
  <NuxtLink
    :to="to"
    active-class="font-bold"
    class="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-500 hover:text-white dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
    role="menuitem"
    :target="target"
    :class="linkClass"
    :data-cy="dataCy"
  >
    <div class="inline-flex items-center">
      <component
        :is="props.icon"
        v-if="!isFontAwesomeIcon(props.icon)"
        :size="18"
        weight="regular"
        class="mr-2"
      />
      <FontAwesomeIcon
        v-else-if="icon?.length"
        :icon="icon"
        class="mr-3"
        :class="iconClass"
      />

      {{ title }}
      <span
        v-if="props.showNew"
        class="ml-2 shrink-0 rounded-full bg-orange-500 px-2 py-0.5 text-xxs font-semibold uppercase tracking-wide text-white"
      >
        New
      </span>
    </div>
  </NuxtLink>
</template>

<style scoped lang="scss"></style>
